export default "__VITE_ASSET__B26RYeou__"